module.exports = __webpack_public_path__ + "assets/media/guillaume-cabane.7b29d0a3.svg";


//////////////////
// WEBPACK FOOTER
// ./src/layouts/SegmentTestimonial/guillaume-cabane.svg
// module id = 2038
// module chunks = 0